module.exports = __webpack_public_path__ + "aecbfdf27f1cc8ff2c42f26d2a6c70b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-06-harrison/diary.jpg
// module id = 572
// module chunks = 0